export enum LanguagesType {
    Latvian = 'lv',
    English = 'en',
    Russian = 'ru',
}